import OfferFreeCoinsList from '@/views/MarketingCenter/OfferFreeCoins/OffersList/OffersList.vue';
import flagKeys from '@/constants/flagKeys';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';

const offerWelcomeCoins = new Route(
  '/marketing-center/offer-free-coins',
  'offer-welcome-coins',
  OfferFreeCoinsList,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    navbar: {
      name: 'Welcome Coins', // TODO apply i18n
      icon: 'welcome-coins',
      description:
        'A unique & powerful marketing tool. Attract new members into your business by offering Coins.'
    },
    pageView: {
      eventLabel: 'Free Coins'
    },
    feature: {
      type: IBusinessType.BOTH,
      title: 'Welcome Coins'
    }
  }
);

export { offerWelcomeCoins };
export default offerWelcomeCoins;
